import { Component, Input, OnInit, ViewChild } from '@angular/core';
// import { CoreModule } from '../../core/core.module';
// import { HeaderComponent } from '../../core/header/header.component';
// import { SidebarComponent } from '../../core/sidebar/sidebar.component';
import { CommonModule } from '@angular/common';
import { LayoutComponent } from '../../core/layout/layout.component';
// import { AuthService } from './../../core/services/auth.service';
// import { DashboardService } from '../../features/dashboard/services/dashboard.service';
// import { ToastrService } from 'ngx-toastr';
// import { ConfirmPunchOutDialog } from '../../shared/components/confirm-dialog/confirm-punchout';
// import { MatDialog } from '@angular/material/dialog';
// import { Router, RouterLink } from '@angular/router';
// import { ImageService } from '../../shared/services/image.service';
// import { CardComponent } from './card/card.component';
// import { ReportService } from '../../features/reports/services/reports.service';
// import {
//   MatExpansionModule,
//   MatExpansionPanel,
// } from '@angular/material/expansion';
// import { NgApexchartsModule } from 'ng-apexcharts';
// import {
//   ApexAxisChartSeries,
//   ApexChart,
//   ChartComponent,
//   ApexDataLabels,
//   ApexPlotOptions,
//   ApexYAxis,
//   ApexLegend,
//   ApexStroke,
//   ApexXAxis,
//   ApexFill,
//   ApexTooltip,
// } from 'ng-apexcharts';
// import { MatSelectModule } from '@angular/material/select';
// import {
//   FormBuilder,
//   FormGroup,
//   FormsModule,
//   ReactiveFormsModule,
// } from '@angular/forms';
// import { EmployeeService } from '../../features/employees/services/employee.service';

// export type ChartOptions = {
//   series: ApexAxisChartSeries;
//   chart: ApexChart;
//   dataLabels: ApexDataLabels;
//   plotOptions: ApexPlotOptions;
//   yaxis: ApexYAxis;
//   xaxis: ApexXAxis;
//   fill: ApexFill;
//   tooltip: ApexTooltip;
//   stroke: ApexStroke;
//   legend: ApexLegend;
// };

// interface Leave {
//   employeeId: string;
//   employeeName: string;
//   leaveDates: string[];
// }

// interface LeaveInfo {
//   upcomingLeaves?: Leave[];
//   onLeave?: Leave[];
//   lateComersToday?: any[];
// }
@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [
    // CoreModule,
    // HeaderComponent,
    // SidebarComponent,
    CommonModule,
    LayoutComponent,
    // RouterLink,
    // CardComponent,
    // MatExpansionModule,
    // NgApexchartsModule,
    // MatSelectModule,
    // FormsModule,
    // ReactiveFormsModule,
  ],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss',
})
export class DashboardComponent {
//   user: any;
//   uaeTime: string;
//   punchInInfo: any;
//   projectID: any;
//   branchwiseOverview: any;
//   holidayData: any = {};
//   branchwiseEmpCount: any = {};
//   columnDefs: any[] = [];
//   public viewPortSize: boolean = false;
//   dashboardStats: any;
//   dashboardStatsLatest: any;
//   projectSummary: any;
//   itemsSummary: any;
//   variationsSummary: any;
//   leaveInfo: any;
//   isReloading = false;
//   accountTypeSummaryReport: any = {};
//   @Input() isAmount: boolean = true;
//   mattabnumber = 0;
//   expenseTotalAmount: any[];
//   monthlyExpense: any;
//   projectItemSummaryList: any;
//   employeeOnVacationDue: any;
//   branchForm: FormGroup;
//   projectBranchForm: FormGroup;
//   warehouseWithItemsSummary: any;

//   public rowSelection: 'single' | 'multiple' = 'multiple';
//   public paginationPageSize = 10;
//   public paginationPageSizeSelector: number[] | boolean = [10];
//   public themeClass: string = 'ag-theme-quartz';
//   public branchData: any[] = [];
//   @ViewChild('chart') chart: ChartComponent;
//   public chartOptions: Partial<ChartOptions>;

//   branchId: any;

//   constructor(
//     private authService: AuthService,
//     public dashboardService: DashboardService,
//     private toastr: ToastrService,
//     private dialog: MatDialog,
//     private router: Router,
//     private imageService: ImageService,
//     private reportService: ReportService,
//     private fb: FormBuilder,
//     private employeeService: EmployeeService
//   ) {
//     this.user = this.authService.getLoggedInUser();

//     this.chartOptions = {
//       series: [
//         {
//           name: 'Daily Purchase',
//           data: this.expenseTotalAmount,
//           color: '#8377D0',
//         },
//       ],
//       chart: {
//         type: 'bar',
//         height: 350,
//       },
//       plotOptions: {
//         bar: {
//           horizontal: false,
//           columnWidth: '100%',
//         },
//       },
//       dataLabels: {
//         enabled: false,
//       },
//       stroke: {
//         show: true,
//         width: 3,
//         colors: ['transparent'],
//       },
//       xaxis: {
//         categories: [
//           'Jan',
//           'Feb',
//           'Mar',
//           'Apr',
//           'May',
//           'Jun',
//           'Jul',
//           'Aug',
//           'Sep',
//           'Oct',
//           'Nov',
//           'Dec',
//         ],
//       },
//       yaxis: {
//         title: {
//           text: 'Total Amount',
//         },
//         labels: {
//           formatter: function (val: number) {
//             return new Intl.NumberFormat('en-US', {
//               style: 'currency',
//               currency: 'AED',
//             }).format(val);
//           },
//         },
//       },
//       fill: {
//         opacity: 1,
//         colors: ['#8377D0'],
//       },
//       tooltip: {
//         y: {
//           formatter: function (val) {
//             return 'AED' + val;
//           },
//         },
//       },
//     };
//   }

//   ngOnInit() {
//     this.getPunchInInfo();
//     this.upcomingHolidayOverview();
//     this.getDashboardStats(false);
//     this.getEmpLeaveInfo();
//     this.getBranchwiseEmpCount();
//     // this.projectModSummary();
//     // this.itemsAssetsSummary();
//     // this.viewVariationsSummary();
//     this.getDailyExpense();
//     this.viewBranchwiseOverview();
//     this.initForm();
//     this.initProjectBranchForm();
//     this.loadBranches();
//     this.employeeOnVacationOverdue();
//     this.viewWarehouseSummary();
//     if (
//       !this.dashboardService.isPunchedOut &&
//       this.dashboardService.punchTime
//     ) {
//       this.resumeTimer();
//     } else {
//       if (this.dashboardService.interval) {
//         clearInterval(this.dashboardService.interval); // Ensure no timer runs
//         this.dashboardService.interval = null;
//       }
//     }
//   }

//   private initForm(): void {
//     const selectedBranchId: any = localStorage.getItem('selectedBranchId');
//     const branch = JSON.parse(selectedBranchId);
//     this.branchId = branch;
//     this.branchForm = this.fb.group({
//       branchName: [this.branchId || 0],
//     });
    
//     this.viewVariationsSummary(selectedBranchId);
//     const endDate = new Date();
//     const startDate = new Date();
//     startDate.setDate(endDate.getDate() - 30);
//     const formattedStartDate = this.formatDate(startDate);
//     const formattedEndDate = this.formatDate(endDate);

//     this.getAccountTypeSummaryReport(
//       formattedStartDate,
//       formattedEndDate,
//       Number(selectedBranchId))

//     this.branchForm
//       .get('branchName')
//       ?.valueChanges.subscribe((selectedBranchId) => {
//         localStorage.setItem('selectedBranchId', selectedBranchId);
//         this.viewVariationsSummary(selectedBranchId);
//         this.getAccountTypeSummaryReportForLast30Days(selectedBranchId);
//       });
//   }

//   private initProjectBranchForm(): void {
//     const selectedBranchId: any = localStorage.getItem('selectedBranchId');
//     const branch = JSON.parse(selectedBranchId);
//     this.branchId = branch;
//     this.projectBranchForm = this.fb.group({
//       projectBranchName: [this.branchId || 0],
//     });
//     this.projectModSummary(selectedBranchId);
//     this.itemsAssetsSummary(selectedBranchId);

//     this.projectBranchForm
//       .get('projectBranchName')
//       ?.valueChanges.subscribe((selectedBranchId) => {
//         localStorage.setItem('selectedBranchId', selectedBranchId);
//         this.projectModSummary(selectedBranchId);
//         this.itemsAssetsSummary(selectedBranchId);
//       });
//   }

//   private loadBranches() {
//     this.employeeService.getBranches().subscribe({
//       next: (branches) => {
//         this.branchData = branches;
//       },
//       error: (error) => console.error(error),
//     });
//   }

//   getPunchInInfo() {
//     this.dashboardService.getPunchInInfo().subscribe({
//       next: (data) => {
//         this.punchInInfo = data;

//         // If checkOutTime exists, the user is punched out
//         if (this.punchInInfo?.checkOutTime) {
//           this.dashboardService.isPunchedOut = true;
//           this.dashboardService.punchTime = null;
//           this.dashboardService.timeDifference = '00:00:00';

//           // Clear any active timer
//           if (this.dashboardService.interval) {
//             clearInterval(this.dashboardService.interval);
//             this.dashboardService.interval = null;
//           }
//           return; // Exit early since no timer needs to be resumed
//         }

//         // If checkInTime exists and no checkOutTime, calculate time difference
//         if (this.punchInInfo?.checkInTime) {
//           const checkInDate = new Date();
//           const [checkInHours, checkInMinutes, checkInSeconds] =
//             this.punchInInfo.checkInTime.split(':');
//           checkInDate.setHours(
//             parseInt(checkInHours),
//             parseInt(checkInMinutes),
//             parseInt(checkInSeconds),
//             0
//           );

//           const currentDubaiTime = new Date().toLocaleString('en-US', {
//             timeZone: 'Asia/Dubai',
//           });
//           const currentDateDubai = new Date(currentDubaiTime);

//           const timeDiffInMs =
//             currentDateDubai.getTime() - checkInDate.getTime();
//           const timeDiffInSec = Math.floor(timeDiffInMs / 1000);

//           const timeDiffHours = Math.floor(timeDiffInSec / 3600);
//           const timeDiffMinutes = Math.floor((timeDiffInSec % 3600) / 60);
//           const timeDiffSeconds = timeDiffInSec % 60;

//           this.dashboardService.timeDifference = `${this.pad(
//             timeDiffHours
//           )}:${this.pad(timeDiffMinutes)}:${this.pad(timeDiffSeconds)}`;
//           this.dashboardService.punchTime = this.punchInInfo.checkInTime;
//           this.dashboardService.isPunchedOut = false;

//           this.resumeTimer(); // Resume the timer since the user is still punched in
//         } else {
//           // Default state if no check-in or check-out time
//           this.dashboardService.isPunchedOut = true;
//           this.dashboardService.punchTime = null;
//           this.dashboardService.timeDifference = '00:00:00';

//           // Clear any active timer
//           if (this.dashboardService.interval) {
//             clearInterval(this.dashboardService.interval);
//             this.dashboardService.interval = null;
//           }
//         }
//       },
//       error: (error) => {
//         console.error(error, 'Error fetching punch-in info');
//       },
//     });
//   }

//   togglePunch() {
//     if (this.dashboardService.isPunchedOut) {
//       // Punch In
//       const punchTime = this.updateTime();
//       const punchDate = this.updateDate();
//       this.dashboardService.punchTime = punchTime;
//       this.dashboardService.isPunchedOut = false;

//       this.logPunchInTime(punchTime, punchDate);
//     } else {
//       // Punch Out
//       const punchTime = this.updateTime();
//       const punchDate = this.updateDate();
//       this.logPunchOutTime(punchTime, punchDate);

//       // Stop the timer immediately
//       if (this.dashboardService.interval) {
//         clearInterval(this.dashboardService.interval);
//         this.dashboardService.interval = null; // Ensure no lingering interval
//       }

//       this.dashboardService.isPunchedOut = true;
//       this.dashboardService.punchTime = null;
//       this.dashboardService.timeDifference = '00:00:00';
//     }
//   }

//   onConfirmPunchOut(): void {
//     if (!this.dashboardService.isPunchedOut) {
//       const dialogRef = this.dialog.open(ConfirmPunchOutDialog);
//       dialogRef.afterClosed().subscribe((result) => {
//         if (result === true) {
//           this.togglePunch();
//         }
//       });
//     }
//   }

//   updateTime() {
//     return new Date().toLocaleTimeString('en-US', {
//       timeZone: 'Asia/Dubai',
//       hour: '2-digit',
//       minute: '2-digit',
//       second: '2-digit',
//       hour12: false,
//     });
//   }

//   updateDate() {
//     const currentDate = new Date().toLocaleDateString('en-US', {
//       year: 'numeric',
//       month: '2-digit',
//       day: '2-digit',
//     });
//     const [month, day, year] = currentDate.split('/');
//     return `${year}-${month}-${day}`;
//   }

//   timeDiff(): void {
//     const currentTime = this.updateTime();

//     if (!this.dashboardService.punchTime) {
//       this.dashboardService.timeDifference = '00:00:00';
//       return;
//     }

//     const [currentHours, currentMinutes, currentSeconds] = currentTime
//       .split(':')
//       .map(Number);
//     const [punchInHours, punchInMinutes, punchInSeconds] =
//       this.dashboardService.punchTime.split(':').map(Number);

//     const totalSeconds1 =
//       currentHours * 3600 + currentMinutes * 60 + currentSeconds;
//     const totalSeconds2 =
//       punchInHours * 3600 + punchInMinutes * 60 + punchInSeconds;

//     let differenceInSeconds = Math.abs(totalSeconds2 - totalSeconds1);

//     const hours = Math.floor(differenceInSeconds / 3600);
//     differenceInSeconds %= 3600;
//     const minutes = Math.floor(differenceInSeconds / 60);
//     const seconds = differenceInSeconds % 60;

//     this.dashboardService.timeDifference = `${this.pad(hours)}:${this.pad(
//       minutes
//     )}:${this.pad(seconds)}`;
//   }

//   resumeTimer() {
//     this.dashboardService.interval = setInterval(() => this.timeDiff(), 1000);
//   }

//   logPunchInTime(time: any, date: any) {
//     this.dashboardService.punchIn(time, date).subscribe({
//       next: (data) => {
//         if (data) {
//           this.toastr.success('Punched in successfully!');
//           this.resumeTimer();
//         }
//       },
//       error: (error) => {
//         this.toastr.error(error?.message, 'Error');
//         this.dashboardService.isPunchedOut = true; // Ensure the state remains consistent
//         this.dashboardService.punchTime = null; // Clear punch time on error
//       },
//     });
//   }

//   logPunchOutTime(time: any, date: any) {
//     this.dashboardService.punchOut(time, date).subscribe({
//       next: (data) => {
//         if (data) {
//           this.toastr.success('Punched out successfully!');
//         }
//       },
//       error: (error) => {
//         this.toastr.error(error?.message, 'Error');
//       },
//     });
//   }

//   pad(num: number): string {
//     return num < 10 ? '0' + num : num.toString();
//   }

//   upcomingHolidayOverview() {
//     this.dashboardService.upcomingHolidayOverview().subscribe({
//       next: (response) => {
//         this.holidayData = response;
//       },
//     });
//   }

//   getBranchwiseEmpCount() {
//     this.dashboardService.viewBranchwiseEmpCount().subscribe({
//       next: (data) => {
//         this.branchwiseEmpCount = data;
//       },
//       error: (error) => {
//         console.error(error, 'Error');
//       },
//     });
//   }

//   reloadDashboard() {
//     this.getDashboardStats(true);
//     if (this.isReloading) return;

//     this.isReloading = true;

//     setTimeout(() => {
//       this.isReloading = false;
//     }, 500);
//   }

//   getDashboardStats(refresh: any) {
//     this.dashboardService.viewDashboardStats(Boolean(refresh)).subscribe({
//       next: (data) => {
//         this.dashboardStats = data;
//       },
//       error: (error) => {
//         console.error(error, 'Error');
//       },
//     });
//   }

//   projectModSummary(id: any) {
//     this.dashboardService.listProjectModSummary(Number(id)).subscribe({
//       next: (data) => {
//         if (data) {
//           this.projectSummary = data;
//         }
//       },
//       error: (error) => {
//         console.error(error, 'Error');
//       },
//     });
//   }

//   itemsAssetsSummary(id: any) {
//     this.dashboardService.listItemsAssetsSummary(Number(id)).subscribe({
//       next: (data) => {
//         if (data) {
//           this.itemsSummary = data;
//         }
//       },
//       error: (error) => {
//         console.error(error, 'Error');
//       },
//     });
//   }

//   viewVariationsSummary(id: any) {
//     this.dashboardService.listVariationsSummary(Number(id)).subscribe({
//       next: (data) => {
//         if (data) {
//           const summaryMap = new Map<string, any>();
//           data.forEach((item: any) => {
//             const projectName = item.projectData?.projectName;
//             if (!summaryMap.has(projectName)) {
//               summaryMap.set(projectName, {
//                 firstQuoteCode: item.quoteCode,
//                 projectName,
//                 count: 1,
//                 totalAmount: item.totalAmount || 0,
//               });
//             } else {
//               const current = summaryMap.get(projectName)!;
//               summaryMap.set(projectName, {
//                 ...current,
//                 count: current.count + 1,
//                 totalAmount: current.totalAmount + (item.totalAmount || 0),
//               });
//             }
//           });
//           this.variationsSummary = Array.from(summaryMap.values());
//         }
//       },
//       error: (error) => {
//         console.error(error, 'Error');
//       },
//     });
//   }

//   viewBranchwiseOverview() {
//     this.dashboardService.listBranchOverview().subscribe({
//       next: (data) => {
//         if (data) {
//           this.branchwiseOverview = data;
//         }
//       },
//       error: (error) => {
//         console.error(error, 'Error');
//       },
//     });
//   }

//   viewWarehouseSummary() {
//     this.dashboardService.getWarehouseSummary().subscribe({
//       next: (data) => {
//         if (data) {
//           this.warehouseWithItemsSummary = data;
//         }
//       },
//       error: (error) => {
//         console.error(error, 'Error');
//       },
//     });
//   }

//   getEmpLeaveInfo() {
//     this.dashboardService.viewEmpLeaveInfo().subscribe({
//       next: async (data: LeaveInfo) => {
//         if (!data) {
//           this.leaveInfo = null;
//           return;
//         }

//         // Function to process profile picture
//         const processProfilePicture = async (employee: any) => {
//           let profilePicture =
//             employee?.profilePicture || 'assets/images/dummy-profile-image.jpg';

//           if (employee?.profilePicture) {
//             try {
//               profilePicture = await this.imageService.getImageAsBase64(
//                 employee.profilePicture
//               );
//             } catch (error) {
//               profilePicture = 'assets/images/dummy-profile-image.jpg';
//             }
//           }

//           return { ...employee, profilePicture };
//         };

//         // Process all categories that contain employees
//         const processCategory = async (category: any[]) => {
//           return Promise.all(category.map(processProfilePicture));
//         };

//         // Apply processing to each category in leaveInfo
//         const processedLeaveInfo = {
//           upcomingLeaves: await processCategory(data.upcomingLeaves || []),
//           onLeave: await processCategory(data.onLeave || []),
//           lateComersToday: await processCategory(data.lateComersToday || []),
//         };

//         this.leaveInfo = processedLeaveInfo;
//       },
//       error: (error) => {
//         console.error(error, 'Error');
//       },
//     });
//   }
//   private getAccountTypeSummaryReportForLast30Days(id:any) {
//     const endDate = new Date();
//     const startDate = new Date();
//     startDate.setDate(endDate.getDate() - 30);
//     const formattedStartDate = this.formatDate(startDate);
//     const formattedEndDate = this.formatDate(endDate);

//     this.getAccountTypeSummaryReport(
//       formattedStartDate,
//       formattedEndDate,
//       Number(id))
//   }

//   // Helper to format date as yyyy-MM-dd
//   private formatDate(date: Date): string {
//     const year = date.getFullYear();
//     const month = String(date.getMonth() + 1).padStart(2, '0');
//     const day = String(date.getDate()).padStart(2, '0');
//     return `${year}-${month}-${day}`;
//   }
//   //fetch account type summary report
//   private getAccountTypeSummaryReport(
//     startDate: string,
//     endDate: string,
//     branchId: number
//   ) {
//     this.reportService
//       .fetchAccountTypeSummaryReport(startDate, endDate, branchId)
//       .subscribe({
//         next: (response) => {
//           this.accountTypeSummaryReport = response;
//         },
//         error: (error) => {
//           console.log('Error fetching account type summary report:', error);
//         },
//       });
//   }

//   getDailyExpense() {
//     this.dashboardService.getDailyExpenseSummary().subscribe({
//       next: (data) => {
//         if (!Array.isArray(data)) {
//           console.error('Error: API response is not an array', data);
//           return;
//         }
//         this.monthlyExpense = [...data];
//         this.expenseTotalAmount = this.monthlyExpense.map(
//           (item: any) => item?.totalAmount ?? 0
//         );

//         this.updateChart();
//       },
//       error: (error) => {
//         console.error(error, 'Error');
//       },
//     });
//   }

//   employeeOnVacationOverdue() {
//     this.dashboardService.getEmployeeVacationOverdue().subscribe({
//       next: (response) => {
//         this.employeeOnVacationDue = response;
//       },
//       error: (error) => {
//         console.log('Error fetching account type summary report:', error);
//       },
//     });
//   }

//   updateChart() {
//     this.chartOptions = {
//       ...this.chartOptions,
//       series: [
//         {
//           name: 'Daily Purchase',
//           data: this.expenseTotalAmount,
//           color: '#8377D0',
//         },
//       ],
//     };
//   }
}
